import type { DocPageContent } from '../docs-content'

const page = {
  order: 9,
  slug: 'source-monitor',
  title: '源监视器工作流',
  description:
    '预览素材、标记入/出范围、选择目标轨道，以及插入或覆盖到时间轴。',
  category: '核心编辑',
  related: ['media', 'timeline', 'scene-browser'],
  sections: [
    {
      title: '打开素材',
      blocks: [
        {
          kind: 'list',
          items: [
            '双击媒体卡片，或在媒体信息中使用**在源监视器中打开**，以载入素材。',
            '监视器标题栏会显示源文件名，并带有用于退出的关闭控件。',
            '源播放独立于时间轴预览，因此你可以在不移动时间轴播放头的情况下拖拽浏览素材。',
            '点击时码读数可在时码与帧号显示之间切换。',
          ],
        },
      ],
    },
    {
      title: '标记入/出范围',
      blocks: [
        {
          kind: 'steps',
          items: [
            '移动到你想要的起始帧，按 `I`（**标记入点**）。',
            '移动到最后一个所需帧的下一帧，按 `O`（**标记出点**）——出点为排他性的。',
            '通过拖动入点手柄、出点手柄或条带上的整个范围进行微调。',
            '使用**入点到出点播放**仅回放该范围，或用 `Alt+X` 清除它并使用完整素材。',
          ],
        },
      ],
    },
    {
      title: '选择目标轨道',
      blocks: [
        {
          kind: 'list',
          items: [
            '**V** 开关用于开启或关闭视频源目标轨道；**A** 开关对音频执行相同操作。',
            '每个开关都有一个目标选择器：**自动**、按名称指定的特定轨道，或**编辑时创建**以新建轨道。',
            '带声视频会在 V 和 A 目标轨道上放置一对已链接的视频与音频。',
            '当前活动的时间轴轨道会预填对应的 V 和 A 目标。',
          ],
        },
      ],
    },
    {
      title: '插入与覆盖',
      blocks: [
        {
          kind: 'paragraph',
          text: '两种编辑都会将标记范围放置到当前时间轴播放头所在帧，然后将播放头推进到新片段的末尾。',
        },
        {
          kind: 'table',
          headers: ['编辑', '按键', '作用'],
          rows: [
            [
              '插入',
              '`,`',
              '将范围插入，并把目标轨道上其后所有素材向右推移。',
            ],
            [
              '覆盖',
              '`.`',
              '替换范围下方的时间轴素材，保留周围的片段不动。',
            ],
          ],
        },
        {
          kind: 'note',
          tone: 'info',
          text: '除非你标记了更短的范围，否则图像在编辑时默认生成为**三秒**片段。',
        },
      ],
    },
    {
      title: '如果编辑无法应用',
      blocks: [
        {
          kind: 'note',
          tone: 'warning',
          text: '请先启用 **V** 或 **A** 目标轨道中的至少一个。要编辑音频，启用 **A**；要编辑无声视频或图像，启用 **V**。被锁定的目标轨道也会阻止编辑——请解锁后重试。',
        },
      ],
    },
  ],
} satisfies DocPageContent

export default page
